import axiosInstance from "../instance/axiosInstance";

class ReferralsApi {
    static async referralsList(page, queryParams) {
    const { type, search_branch, search_department, search_value } = queryParams;
    let url = `/referrals/list?page=${page}`;

    if(type) url += `&type=${type}`;
    if (search_branch) url += `&search_branch=${search_branch}`;
    if (search_department) url += `&search_department=${search_department}`;
    if (search_value) url += `&search_value=${search_value}`;

    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getUserPendingReferrals() {
    try {
      const response = await axiosInstance.get(`/referrals/getPendingCount`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getReferralDetail(id) {
    try {
      const response = await axiosInstance.get(`/referrals/view/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteReferral(id) {
    try {
      const response = await axiosInstance.get(`/referrals/delete/${id}`);
      if (response) return response.data;
    } catch (error) { 
      return error;
    }
  }
}

export default ReferralsApi;